import React from 'react';
import Slider from '../component/Mainbanner'



function Mainb() {
    return (
        <section id="main_slide_je">
            <Slider></Slider>
        </section>
    )
}

export default Mainb
